import {
  EndScreenOrigin,
  EndScreenOriginValue,
  EndScreenTypeValue
} from './end-screen-types';

interface CloseBtn {
  delay: number;
  size: number;
}

interface EndScreenConfig {
  endScreen?: {
    closeBtn?: {
      delay?: number;
      size?: number;
    };
  };
  closeBtn?: {
    autoCloseDelay?: number;
  };
}

export interface EndScreenConstructorParams {
  config: EndScreenConfig;
}

export interface AppPreviewContent {
  icon: string;
  name: string;
}

export class EndScreen {
  closeBtn: CloseBtn;
  duration: number;
  origin: EndScreenOriginValue;
  type!: EndScreenTypeValue;
  content?: AppPreviewContent | string;

  constructor({ config }: EndScreenConstructorParams) {
    this.closeBtn = this._getCloseBtn(config);
    this.duration = this._getDuration(config);
    this.origin = EndScreenOrigin.MANAGED;
  }

  isValid(): boolean {
    return false;
  }

  getClickUrl(): string | null {
    return null;
  }

  _getCloseBtn(config: EndScreenConfig): CloseBtn {
    const closeBtn = config && config.endScreen && config.endScreen.closeBtn;
    const showCloseDelay = (closeBtn && closeBtn.delay) || 0;
    const closeSize = (closeBtn && closeBtn.size) || 100;

    return {
      delay: showCloseDelay,
      size: closeSize
    };
  }

  _getDuration(config: EndScreenConfig): number {
    const duration =
      config && config.closeBtn && config.closeBtn.autoCloseDelay;
    return duration || 0;
  }
}
